module.exports = __webpack_public_path__ + "img/newchris-51.d1b34ad6.jpg";